import { useRoutes } from "react-router-dom";
import { useLocalRoutes } from "./routes/useRoutes";
import { Suspense } from "react";
import Loading from "@/components/ui/Loading";
import { Toaster } from "react-hot-toast";

import * as Sentry from "@sentry/react";

function App() {
  const routes = useLocalRoutes();
  const router = useRoutes(routes);
  return (
    <Suspense fallback={<Loading />}>
      <Toaster position="top-center" />
      {router}
    </Suspense>
  );
}

const AppWithProfiler = Sentry.withProfiler(App);
export default AppWithProfiler;
